import { render, staticRenderFns } from "./MenuSettings.vue?vue&type=template&id=09a05bbf&scoped=true"
import script from "./MenuSettings.vue?vue&type=script&lang=js"
export * from "./MenuSettings.vue?vue&type=script&lang=js"
import style0 from "./MenuSettings.vue?vue&type=style&index=0&id=09a05bbf&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a05bbf",
  null
  
)

export default component.exports